module.exports = "/static/media/document_icon.66cccc0b.svg";